module.exports = __webpack_public_path__ + "static/media/YourLonelyNightsareOverBookJacket.901f7ea6.jpg";